import React, { useEffect } from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';
import TextInput from '../../../lib/TextField';
import en from '../../../lang/en-us';
import { useState } from 'react';
import { SubmitButton, SubmitButtonWithLoader } from '../../../lib/Button';
import { connect, useDispatch } from 'react-redux';
import { giveFeedback } from '../../../redux-store/actions/nct';
import { emailRegex, isAlphaNumeric, isMobileDevice } from '../../../utils/constants';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router';
import ActionHeader from '../../common/ActionHeader';
import { getDepoIds, submitDepoRequest } from '../../../redux-store/actions/depReq';
import { showHelperText } from '../commercial/Switch/utils';
import getDpPayload from './getDpPayload';
import { isNumericLiteral } from 'typescript';
import { isMobile } from '../../quick-links/faq';
const { myProfile, common } = en;

export type DepositFieldType = {
    dpId: string;
    query: string;
    customDpId: string;
};

const depositotyRequestInitialValues = {
    dpId: 'other',
    customDpId: '',
    query: '',
};

const depReqValidationSchema = yup.object({
    dpId: yup.string().required('Please select your DP-ID'),
    query: yup
        .string()
        .trim()
        .required('Please enter your query')
        .max(1000, 'Maximum allowed characters are 1000'),
    customDpId: yup
        .string()
        .trim()
        .min(16, 'Minimum 16 characters')
        .when('dpId', {
            is: (dpId: string) => dpId === 'other',
            then: yup.string().required('Please enter your DP-ID'),
        }),
});

export const DepositoryRequest = (props: {}) => {
    const [depIdMap, setDepIdMap] = useState<Record<string, string>>({});
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const formik = useFormik<DepositFieldType>({
        initialValues: depositotyRequestInitialValues,
        onSubmit: () => {},
        validationSchema: depReqValidationSchema,
        validateOnMount: true,
    });

    useEffect(() => {
        async function callApi() {
            try {
                setFetching(true);
                const {
                    body: { dpClientIdList },
                }: { body: GetDepoIdResType } = await getDepoIds(dispatch);
                const depIdClientIdMap: { [key: string]: string } = {};
                for (let i = 0; i < dpClientIdList.length; ++i) {
                    const { dpId, clientId } = dpClientIdList[i];
                    depIdClientIdMap[dpId] = clientId;
                }
                setDepIdMap(depIdClientIdMap);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setFetching(false);
            }
        }
        callApi();
    }, []);

    useEffect(() => {
        if (depIdMap && Object.keys(depIdMap).length > 0) {
            formik.setFieldValue('dpId', Object.keys(depIdMap)[0]);
        }
    }, [depIdMap]);

    const handleSubmit = async () => {
        formik.submitForm();
        if (formik.isValid) {
            const payload = getDpPayload(formik.values, depIdMap);
            try {
                setLoading(true);
                const res = await submitDepoRequest(payload)(dispatch);
                console.log(res, 'res');
                history.push(`/portal/depreq-success`, {
                    // reqId: '12323'
                    reqId: res.body.reqId,
                });
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleCustomDpIdChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        const value = e.target.value;
        if (isAlphaNumeric(value) && value.length <= 16 && !value.includes(' ')) {
            formik.setFieldValue('customDpId', value);
        }
    };

    return (
        <div className="curved-bg">
            <Dialog maxWidth={'sm'} open={fetching} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p style={{ marginTop: '12px' }}>{'Fetching DP Ids...'}</p>
                </div>
            </Dialog>
            <ActionHeader header={myProfile.dpHeading} />
            <div className="curved-bg-content" style={{ height: '100%' }}>
                <div
                    className="curved-bg-content-inner"
                    style={{
                        width: '85%',
                        marginRight: 'auto',
                        marginLeft: 'auto',
                    }}
                >
                    <FormControl variant="outlined">
                        <InputLabel id="feedback-service-label">{myProfile.selectDpId}</InputLabel>
                        <Select
                            labelId="feedback-service-label"
                            value={formik.values.dpId}
                            onChange={formik.handleChange}
                            id="feedback-service"
                            name="dpId"
                        >
                            {Object.keys(depIdMap).map((depId) => {
                                return (
                                    <MenuItem value={depId}>
                                        {depId}
                                        {depIdMap[depId]}
                                    </MenuItem>
                                );
                            })}
                            <MenuItem value="other">Other</MenuItem>{' '}
                        </Select>{' '}
                        <FormHelperText style={{ color: 'red', fontSize: 12, padding: 4 }}>
                            {showHelperText(formik, 'dpId')}
                        </FormHelperText>
                    </FormControl>
                    {formik.values.dpId === 'other' && (
                        <>
                            <FormHelperText style={{ color: 'red', fontSize: 12, padding: 4 }}>
                                {showHelperText(formik, 'customDpId')}
                            </FormHelperText>
                            <TextInput
                                id="register-complaint-input"
                                value={formik.values.customDpId}
                                onChange={handleCustomDpIdChange}
                                label={myProfile.enterDpId}
                                variant="outlined"
                                name="customDpId"
                            />
                        </>
                    )}
                    <FormHelperText style={{ color: 'red', fontSize: 12, padding: 4 }}>
                        {showHelperText(formik, 'query')}
                    </FormHelperText>
                    <TextInput
                        id="register-complaint-input"
                        multiline
                        value={formik.values.query}
                        onChange={formik.handleChange}
                        label={myProfile.enterQuery}
                        rows={7}
                        variant="outlined"
                        name="query"
                    />
                    <div className="buttons" style={{ width: '95%' }}>
                        <SubmitButtonWithLoader
                            className="customBtn"
                            style={{
                                width: isMobileDevice() ? '70%' : '40%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                            onClick={handleSubmit}
                            loading={loading}
                            label="Submit"
                            labelWhileLoading="Submitting..."
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
